// Cupom que veio no link (01/11/2026): os e-mails e o WhatsApp automáticos levam `?cupom=VOLTA10` / `?cupom=BLINK10` no
// botão. O MagicLinkGate guarda o código ao abrir o site (e tira da barra de endereço) e o pagamento aplica sozinho —
// a pessoa não precisa digitar. Vale 14 dias; se o servidor recusar (já usou, não é a 1ª compra...), some.
import { safeGetItem, safeRemoveItem, safeSetItem } from "@/lib/safeStorage";

const KEY = "blink_pending_coupon";
const TTL_MS = 14 * 24 * 60 * 60 * 1000;

/** Lê `?cupom=` da URL atual, guarda e limpa da barra de endereço. */
export function capturePendingCouponFromUrl(): void {
  try {
    const url = new URL(window.location.href);
    const raw = url.searchParams.get("cupom");
    if (raw == null) return;
    const code = raw.trim().toUpperCase();
    if (/^[A-Z0-9]{3,24}$/.test(code)) safeSetItem(KEY, JSON.stringify({ code, at: Date.now() }));
    url.searchParams.delete("cupom");
    window.history.replaceState(window.history.state, "", url.pathname + (url.searchParams.toString() ? `?${url.searchParams}` : "") + url.hash);
  } catch { /* sem cupom */ }
}

/** Código guardado e ainda válido (ou null). */
export function getPendingCoupon(): string | null {
  try {
    const v = JSON.parse(safeGetItem(KEY) || "null") as { code?: string; at?: number } | null;
    if (!v?.code) return null;
    if (!v.at || Date.now() - v.at > TTL_MS) { safeRemoveItem(KEY); return null; }
    return v.code;
  } catch { return null; }
}

export function clearPendingCoupon(): void {
  safeRemoveItem(KEY);
}
